export default __webpack_public_path__ + "static/media/react_filestack.cb4bc4c0.svg";